// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__w-B0f","infoBtn":"quickbooks_infoBtn__1sj-B","formBox":"quickbooks_formBox__1HTI6","formFooter":"quickbooks_formFooter__3HJg3"};